// extracted by mini-css-extract-plugin
module.exports = {"Box":"DeviceSelector_Box__29M0h","Select":"DeviceSelector_Select__3hwQo","BoxHeader":"DeviceSelector_BoxHeader__1iLmp"};